/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppApiActivityRouteImport } from './routes/_app/api-activity'
import { Route as AppCustomersRouteImport } from './routes/_app/customers'
import { Route as AppExpensesRouteImport } from './routes/_app/expenses'
import { Route as AppIntegrationRouteImport } from './routes/_app/integration'
import { Route as AppInvoicesRouteImport } from './routes/_app/invoices'
import { Route as AppNotesRouteImport } from './routes/_app/notes'
import { Route as AppPaymentsRouteImport } from './routes/_app/payments'
import { Route as AppProductsRouteImport } from './routes/_app/products'
import { Route as AppPurchasesRouteImport } from './routes/_app/purchases'
import { Route as AppReceptionsRouteImport } from './routes/_app/receptions'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AppTicketsRouteImport } from './routes/_app/tickets'
import { Route as PTokenRouteImport } from './routes/p.$token'
import { Route as ResetPasswordTokenRouteImport } from './routes/reset-password.$token'
import { Route as AppCustomersIdRouteImport } from './routes/_app/customers_.$id'
import { Route as AppDocumentsIdRouteImport } from './routes/_app/documents/$id'
import { Route as AppDocumentsNewRouteImport } from './routes/_app/documents/new'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppProjectsIdRouteImport } from './routes/_app/projects/$id'
import { Route as AppProjectsComplianceRouteImport } from './routes/_app/projects/compliance'
import { Route as AppProjectsPositionsRouteImport } from './routes/_app/projects/positions'
import { Route as AppProjectsSettlementsRouteImport } from './routes/_app/projects/settlements'
import { Route as AppProjectsUnassignedRouteImport } from './routes/_app/projects/unassigned'
import { Route as AppQuotesIndexRouteImport } from './routes/_app/quotes/index'
import { Route as AppQuotesIdRouteImport } from './routes/_app/quotes/$id'
import { Route as AppQuotesNewRouteImport } from './routes/_app/quotes/new'
import { Route as AppRecurringIndexRouteImport } from './routes/_app/recurring/index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsApiRouteImport } from './routes/_app/settings/api'
import { Route as AppSettingsBranchesRouteImport } from './routes/_app/settings/branches'
import { Route as AppSettingsCompanyRouteImport } from './routes/_app/settings/company'
import { Route as AppSettingsEmailRouteImport } from './routes/_app/settings/email'
import { Route as AppSettingsHaciendaRouteImport } from './routes/_app/settings/hacienda'
import { Route as AppSettingsProfileRouteImport } from './routes/_app/settings/profile'
import { Route as AppSettingsTeamRouteImport } from './routes/_app/settings/team'
import { Route as AppSettingsTermsRouteImport } from './routes/_app/settings/terms'
import { Route as AppDocumentsEditIdRouteImport } from './routes/_app/documents/edit.$id'
import { Route as AppProjectsWorkersIndexRouteImport } from './routes/_app/projects/workers/index'
import { Route as AppProjectsWorkersIdRouteImport } from './routes/_app/projects/workers/$id'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppApiActivityRoute = AppApiActivityRouteImport.update({
  id: '/api-activity',
  path: '/api-activity',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersRoute = AppCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AppRoute,
} as any)
const AppExpensesRoute = AppExpensesRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => AppRoute,
} as any)
const AppIntegrationRoute = AppIntegrationRouteImport.update({
  id: '/integration',
  path: '/integration',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesRoute = AppInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AppRoute,
} as any)
const AppNotesRoute = AppNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => AppRoute,
} as any)
const AppPaymentsRoute = AppPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsRoute = AppProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasesRoute = AppPurchasesRouteImport.update({
  id: '/purchases',
  path: '/purchases',
  getParentRoute: () => AppRoute,
} as any)
const AppReceptionsRoute = AppReceptionsRouteImport.update({
  id: '/receptions',
  path: '/receptions',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppTicketsRoute = AppTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => AppRoute,
} as any)
const PTokenRoute = PTokenRouteImport.update({
  id: '/p/$token',
  path: '/p/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordTokenRoute = ResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCustomersIdRoute = AppCustomersIdRouteImport.update({
  id: '/customers_/$id',
  path: '/customers/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsIdRoute = AppDocumentsIdRouteImport.update({
  id: '/documents/$id',
  path: '/documents/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsNewRoute = AppDocumentsNewRouteImport.update({
  id: '/documents/new',
  path: '/documents/new',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIdRoute = AppProjectsIdRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsComplianceRoute = AppProjectsComplianceRouteImport.update({
  id: '/projects/compliance',
  path: '/projects/compliance',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsPositionsRoute = AppProjectsPositionsRouteImport.update({
  id: '/projects/positions',
  path: '/projects/positions',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsSettlementsRoute = AppProjectsSettlementsRouteImport.update({
  id: '/projects/settlements',
  path: '/projects/settlements',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsUnassignedRoute = AppProjectsUnassignedRouteImport.update({
  id: '/projects/unassigned',
  path: '/projects/unassigned',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesIndexRoute = AppQuotesIndexRouteImport.update({
  id: '/quotes/',
  path: '/quotes/',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesIdRoute = AppQuotesIdRouteImport.update({
  id: '/quotes/$id',
  path: '/quotes/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesNewRoute = AppQuotesNewRouteImport.update({
  id: '/quotes/new',
  path: '/quotes/new',
  getParentRoute: () => AppRoute,
} as any)
const AppRecurringIndexRoute = AppRecurringIndexRouteImport.update({
  id: '/recurring/',
  path: '/recurring/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsApiRoute = AppSettingsApiRouteImport.update({
  id: '/api',
  path: '/api',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsBranchesRoute = AppSettingsBranchesRouteImport.update({
  id: '/branches',
  path: '/branches',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsCompanyRoute = AppSettingsCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsEmailRoute = AppSettingsEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsHaciendaRoute = AppSettingsHaciendaRouteImport.update({
  id: '/hacienda',
  path: '/hacienda',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTeamRoute = AppSettingsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTermsRoute = AppSettingsTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppDocumentsEditIdRoute = AppDocumentsEditIdRouteImport.update({
  id: '/documents/edit/$id',
  path: '/documents/edit/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsWorkersIndexRoute = AppProjectsWorkersIndexRouteImport.update({
  id: '/projects/workers/',
  path: '/projects/workers/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsWorkersIdRoute = AppProjectsWorkersIdRouteImport.update({
  id: '/projects/workers/$id',
  path: '/projects/workers/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/admin': typeof AppAdminRoute
  '/api-activity': typeof AppApiActivityRoute
  '/customers': typeof AppCustomersRoute
  '/expenses': typeof AppExpensesRoute
  '/integration': typeof AppIntegrationRoute
  '/invoices': typeof AppInvoicesRoute
  '/notes': typeof AppNotesRoute
  '/payments': typeof AppPaymentsRoute
  '/products': typeof AppProductsRoute
  '/purchases': typeof AppPurchasesRoute
  '/receptions': typeof AppReceptionsRoute
  '/reports': typeof AppReportsRoute
  '/tickets': typeof AppTicketsRoute
  '/p/$token': typeof PTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/customers/$id': typeof AppCustomersIdRoute
  '/documents/$id': typeof AppDocumentsIdRoute
  '/documents/new': typeof AppDocumentsNewRoute
  '/projects/$id': typeof AppProjectsIdRoute
  '/projects/compliance': typeof AppProjectsComplianceRoute
  '/projects/positions': typeof AppProjectsPositionsRoute
  '/projects/settlements': typeof AppProjectsSettlementsRoute
  '/projects/unassigned': typeof AppProjectsUnassignedRoute
  '/quotes/$id': typeof AppQuotesIdRoute
  '/quotes/new': typeof AppQuotesNewRoute
  '/settings/api': typeof AppSettingsApiRoute
  '/settings/branches': typeof AppSettingsBranchesRoute
  '/settings/company': typeof AppSettingsCompanyRoute
  '/settings/email': typeof AppSettingsEmailRoute
  '/settings/hacienda': typeof AppSettingsHaciendaRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/team': typeof AppSettingsTeamRoute
  '/settings/terms': typeof AppSettingsTermsRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/quotes/': typeof AppQuotesIndexRoute
  '/recurring/': typeof AppRecurringIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/documents/edit/$id': typeof AppDocumentsEditIdRoute
  '/projects/workers/$id': typeof AppProjectsWorkersIdRoute
  '/projects/workers/': typeof AppProjectsWorkersIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/admin': typeof AppAdminRoute
  '/api-activity': typeof AppApiActivityRoute
  '/customers': typeof AppCustomersRoute
  '/expenses': typeof AppExpensesRoute
  '/integration': typeof AppIntegrationRoute
  '/invoices': typeof AppInvoicesRoute
  '/notes': typeof AppNotesRoute
  '/payments': typeof AppPaymentsRoute
  '/products': typeof AppProductsRoute
  '/purchases': typeof AppPurchasesRoute
  '/receptions': typeof AppReceptionsRoute
  '/reports': typeof AppReportsRoute
  '/tickets': typeof AppTicketsRoute
  '/p/$token': typeof PTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/': typeof AppIndexRoute
  '/customers/$id': typeof AppCustomersIdRoute
  '/documents/$id': typeof AppDocumentsIdRoute
  '/documents/new': typeof AppDocumentsNewRoute
  '/projects/$id': typeof AppProjectsIdRoute
  '/projects/compliance': typeof AppProjectsComplianceRoute
  '/projects/positions': typeof AppProjectsPositionsRoute
  '/projects/settlements': typeof AppProjectsSettlementsRoute
  '/projects/unassigned': typeof AppProjectsUnassignedRoute
  '/quotes/$id': typeof AppQuotesIdRoute
  '/quotes/new': typeof AppQuotesNewRoute
  '/settings/api': typeof AppSettingsApiRoute
  '/settings/branches': typeof AppSettingsBranchesRoute
  '/settings/company': typeof AppSettingsCompanyRoute
  '/settings/email': typeof AppSettingsEmailRoute
  '/settings/hacienda': typeof AppSettingsHaciendaRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/team': typeof AppSettingsTeamRoute
  '/settings/terms': typeof AppSettingsTermsRoute
  '/projects': typeof AppProjectsIndexRoute
  '/quotes': typeof AppQuotesIndexRoute
  '/recurring': typeof AppRecurringIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/documents/edit/$id': typeof AppDocumentsEditIdRoute
  '/projects/workers/$id': typeof AppProjectsWorkersIdRoute
  '/projects/workers': typeof AppProjectsWorkersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/_app/admin': typeof AppAdminRoute
  '/_app/api-activity': typeof AppApiActivityRoute
  '/_app/customers': typeof AppCustomersRoute
  '/_app/expenses': typeof AppExpensesRoute
  '/_app/integration': typeof AppIntegrationRoute
  '/_app/invoices': typeof AppInvoicesRoute
  '/_app/notes': typeof AppNotesRoute
  '/_app/payments': typeof AppPaymentsRoute
  '/_app/products': typeof AppProductsRoute
  '/_app/purchases': typeof AppPurchasesRoute
  '/_app/receptions': typeof AppReceptionsRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/tickets': typeof AppTicketsRoute
  '/p/$token': typeof PTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/customers_/$id': typeof AppCustomersIdRoute
  '/_app/documents/$id': typeof AppDocumentsIdRoute
  '/_app/documents/new': typeof AppDocumentsNewRoute
  '/_app/projects/$id': typeof AppProjectsIdRoute
  '/_app/projects/compliance': typeof AppProjectsComplianceRoute
  '/_app/projects/positions': typeof AppProjectsPositionsRoute
  '/_app/projects/settlements': typeof AppProjectsSettlementsRoute
  '/_app/projects/unassigned': typeof AppProjectsUnassignedRoute
  '/_app/quotes/$id': typeof AppQuotesIdRoute
  '/_app/quotes/new': typeof AppQuotesNewRoute
  '/_app/settings/api': typeof AppSettingsApiRoute
  '/_app/settings/branches': typeof AppSettingsBranchesRoute
  '/_app/settings/company': typeof AppSettingsCompanyRoute
  '/_app/settings/email': typeof AppSettingsEmailRoute
  '/_app/settings/hacienda': typeof AppSettingsHaciendaRoute
  '/_app/settings/profile': typeof AppSettingsProfileRoute
  '/_app/settings/team': typeof AppSettingsTeamRoute
  '/_app/settings/terms': typeof AppSettingsTermsRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/quotes/': typeof AppQuotesIndexRoute
  '/_app/recurring/': typeof AppRecurringIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/documents/edit/$id': typeof AppDocumentsEditIdRoute
  '/_app/projects/workers/$id': typeof AppProjectsWorkersIdRoute
  '/_app/projects/workers/': typeof AppProjectsWorkersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/settings'
    | '/admin'
    | '/api-activity'
    | '/customers'
    | '/expenses'
    | '/integration'
    | '/invoices'
    | '/notes'
    | '/payments'
    | '/products'
    | '/purchases'
    | '/receptions'
    | '/reports'
    | '/tickets'
    | '/p/$token'
    | '/reset-password/$token'
    | '/customers/$id'
    | '/documents/$id'
    | '/documents/new'
    | '/projects/$id'
    | '/projects/compliance'
    | '/projects/positions'
    | '/projects/settlements'
    | '/projects/unassigned'
    | '/quotes/$id'
    | '/quotes/new'
    | '/settings/api'
    | '/settings/branches'
    | '/settings/company'
    | '/settings/email'
    | '/settings/hacienda'
    | '/settings/profile'
    | '/settings/team'
    | '/settings/terms'
    | '/projects/'
    | '/quotes/'
    | '/recurring/'
    | '/settings/'
    | '/documents/edit/$id'
    | '/projects/workers/$id'
    | '/projects/workers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/admin'
    | '/api-activity'
    | '/customers'
    | '/expenses'
    | '/integration'
    | '/invoices'
    | '/notes'
    | '/payments'
    | '/products'
    | '/purchases'
    | '/receptions'
    | '/reports'
    | '/tickets'
    | '/p/$token'
    | '/reset-password/$token'
    | '/'
    | '/customers/$id'
    | '/documents/$id'
    | '/documents/new'
    | '/projects/$id'
    | '/projects/compliance'
    | '/projects/positions'
    | '/projects/settlements'
    | '/projects/unassigned'
    | '/quotes/$id'
    | '/quotes/new'
    | '/settings/api'
    | '/settings/branches'
    | '/settings/company'
    | '/settings/email'
    | '/settings/hacienda'
    | '/settings/profile'
    | '/settings/team'
    | '/settings/terms'
    | '/projects'
    | '/quotes'
    | '/recurring'
    | '/settings'
    | '/documents/edit/$id'
    | '/projects/workers/$id'
    | '/projects/workers'
  id:
    | '__root__'
    | '/_app'
    | '/forgot-password'
    | '/login'
    | '/_app/settings'
    | '/_app/admin'
    | '/_app/api-activity'
    | '/_app/customers'
    | '/_app/expenses'
    | '/_app/integration'
    | '/_app/invoices'
    | '/_app/notes'
    | '/_app/payments'
    | '/_app/products'
    | '/_app/purchases'
    | '/_app/receptions'
    | '/_app/reports'
    | '/_app/tickets'
    | '/p/$token'
    | '/reset-password/$token'
    | '/_app/'
    | '/_app/customers_/$id'
    | '/_app/documents/$id'
    | '/_app/documents/new'
    | '/_app/projects/$id'
    | '/_app/projects/compliance'
    | '/_app/projects/positions'
    | '/_app/projects/settlements'
    | '/_app/projects/unassigned'
    | '/_app/quotes/$id'
    | '/_app/quotes/new'
    | '/_app/settings/api'
    | '/_app/settings/branches'
    | '/_app/settings/company'
    | '/_app/settings/email'
    | '/_app/settings/hacienda'
    | '/_app/settings/profile'
    | '/_app/settings/team'
    | '/_app/settings/terms'
    | '/_app/projects/'
    | '/_app/quotes/'
    | '/_app/recurring/'
    | '/_app/settings/'
    | '/_app/documents/edit/$id'
    | '/_app/projects/workers/$id'
    | '/_app/projects/workers/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PTokenRoute: typeof PTokenRoute
  ResetPasswordTokenRoute: typeof ResetPasswordTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/api-activity': {
      id: '/_app/api-activity'
      path: '/api-activity'
      fullPath: '/api-activity'
      preLoaderRoute: typeof AppApiActivityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers': {
      id: '/_app/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AppCustomersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/expenses': {
      id: '/_app/expenses'
      path: '/expenses'
      fullPath: '/expenses'
      preLoaderRoute: typeof AppExpensesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/integration': {
      id: '/_app/integration'
      path: '/integration'
      fullPath: '/integration'
      preLoaderRoute: typeof AppIntegrationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices': {
      id: '/_app/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AppInvoicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notes': {
      id: '/_app/notes'
      path: '/notes'
      fullPath: '/notes'
      preLoaderRoute: typeof AppNotesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payments': {
      id: '/_app/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof AppPaymentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products': {
      id: '/_app/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AppProductsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchases': {
      id: '/_app/purchases'
      path: '/purchases'
      fullPath: '/purchases'
      preLoaderRoute: typeof AppPurchasesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/receptions': {
      id: '/_app/receptions'
      path: '/receptions'
      fullPath: '/receptions'
      preLoaderRoute: typeof AppReceptionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tickets': {
      id: '/_app/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof AppTicketsRouteImport
      parentRoute: typeof AppRoute
    }
    '/p/$token': {
      id: '/p/$token'
      path: '/p/$token'
      fullPath: '/p/$token'
      preLoaderRoute: typeof PTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/$token': {
      id: '/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/customers_/$id': {
      id: '/_app/customers_/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof AppCustomersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/$id': {
      id: '/_app/documents/$id'
      path: '/documents/$id'
      fullPath: '/documents/$id'
      preLoaderRoute: typeof AppDocumentsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/new': {
      id: '/_app/documents/new'
      path: '/documents/new'
      fullPath: '/documents/new'
      preLoaderRoute: typeof AppDocumentsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$id': {
      id: '/_app/projects/$id'
      path: '/projects/$id'
      fullPath: '/projects/$id'
      preLoaderRoute: typeof AppProjectsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/compliance': {
      id: '/_app/projects/compliance'
      path: '/projects/compliance'
      fullPath: '/projects/compliance'
      preLoaderRoute: typeof AppProjectsComplianceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/positions': {
      id: '/_app/projects/positions'
      path: '/projects/positions'
      fullPath: '/projects/positions'
      preLoaderRoute: typeof AppProjectsPositionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/settlements': {
      id: '/_app/projects/settlements'
      path: '/projects/settlements'
      fullPath: '/projects/settlements'
      preLoaderRoute: typeof AppProjectsSettlementsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/unassigned': {
      id: '/_app/projects/unassigned'
      path: '/projects/unassigned'
      fullPath: '/projects/unassigned'
      preLoaderRoute: typeof AppProjectsUnassignedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/': {
      id: '/_app/quotes/'
      path: '/quotes'
      fullPath: '/quotes/'
      preLoaderRoute: typeof AppQuotesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/$id': {
      id: '/_app/quotes/$id'
      path: '/quotes/$id'
      fullPath: '/quotes/$id'
      preLoaderRoute: typeof AppQuotesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/new': {
      id: '/_app/quotes/new'
      path: '/quotes/new'
      fullPath: '/quotes/new'
      preLoaderRoute: typeof AppQuotesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/recurring/': {
      id: '/_app/recurring/'
      path: '/recurring'
      fullPath: '/recurring/'
      preLoaderRoute: typeof AppRecurringIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/api': {
      id: '/_app/settings/api'
      path: '/api'
      fullPath: '/settings/api'
      preLoaderRoute: typeof AppSettingsApiRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/branches': {
      id: '/_app/settings/branches'
      path: '/branches'
      fullPath: '/settings/branches'
      preLoaderRoute: typeof AppSettingsBranchesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/company': {
      id: '/_app/settings/company'
      path: '/company'
      fullPath: '/settings/company'
      preLoaderRoute: typeof AppSettingsCompanyRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/email': {
      id: '/_app/settings/email'
      path: '/email'
      fullPath: '/settings/email'
      preLoaderRoute: typeof AppSettingsEmailRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/hacienda': {
      id: '/_app/settings/hacienda'
      path: '/hacienda'
      fullPath: '/settings/hacienda'
      preLoaderRoute: typeof AppSettingsHaciendaRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/profile': {
      id: '/_app/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/team': {
      id: '/_app/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof AppSettingsTeamRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/terms': {
      id: '/_app/settings/terms'
      path: '/terms'
      fullPath: '/settings/terms'
      preLoaderRoute: typeof AppSettingsTermsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/documents/edit/$id': {
      id: '/_app/documents/edit/$id'
      path: '/documents/edit/$id'
      fullPath: '/documents/edit/$id'
      preLoaderRoute: typeof AppDocumentsEditIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/workers/': {
      id: '/_app/projects/workers/'
      path: '/projects/workers'
      fullPath: '/projects/workers/'
      preLoaderRoute: typeof AppProjectsWorkersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/workers/$id': {
      id: '/_app/projects/workers/$id'
      path: '/projects/workers/$id'
      fullPath: '/projects/workers/$id'
      preLoaderRoute: typeof AppProjectsWorkersIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppSettingsRouteRouteChildren {
  AppSettingsApiRoute: typeof AppSettingsApiRoute
  AppSettingsBranchesRoute: typeof AppSettingsBranchesRoute
  AppSettingsCompanyRoute: typeof AppSettingsCompanyRoute
  AppSettingsEmailRoute: typeof AppSettingsEmailRoute
  AppSettingsHaciendaRoute: typeof AppSettingsHaciendaRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsTeamRoute: typeof AppSettingsTeamRoute
  AppSettingsTermsRoute: typeof AppSettingsTermsRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsApiRoute: AppSettingsApiRoute,
  AppSettingsBranchesRoute: AppSettingsBranchesRoute,
  AppSettingsCompanyRoute: AppSettingsCompanyRoute,
  AppSettingsEmailRoute: AppSettingsEmailRoute,
  AppSettingsHaciendaRoute: AppSettingsHaciendaRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsTeamRoute: AppSettingsTeamRoute,
  AppSettingsTermsRoute: AppSettingsTermsRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppRouteChildren {
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppAdminRoute: typeof AppAdminRoute
  AppApiActivityRoute: typeof AppApiActivityRoute
  AppCustomersRoute: typeof AppCustomersRoute
  AppExpensesRoute: typeof AppExpensesRoute
  AppIntegrationRoute: typeof AppIntegrationRoute
  AppInvoicesRoute: typeof AppInvoicesRoute
  AppNotesRoute: typeof AppNotesRoute
  AppPaymentsRoute: typeof AppPaymentsRoute
  AppProductsRoute: typeof AppProductsRoute
  AppPurchasesRoute: typeof AppPurchasesRoute
  AppReceptionsRoute: typeof AppReceptionsRoute
  AppReportsRoute: typeof AppReportsRoute
  AppTicketsRoute: typeof AppTicketsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCustomersIdRoute: typeof AppCustomersIdRoute
  AppDocumentsIdRoute: typeof AppDocumentsIdRoute
  AppDocumentsNewRoute: typeof AppDocumentsNewRoute
  AppProjectsIdRoute: typeof AppProjectsIdRoute
  AppProjectsComplianceRoute: typeof AppProjectsComplianceRoute
  AppProjectsPositionsRoute: typeof AppProjectsPositionsRoute
  AppProjectsSettlementsRoute: typeof AppProjectsSettlementsRoute
  AppProjectsUnassignedRoute: typeof AppProjectsUnassignedRoute
  AppQuotesIdRoute: typeof AppQuotesIdRoute
  AppQuotesNewRoute: typeof AppQuotesNewRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppQuotesIndexRoute: typeof AppQuotesIndexRoute
  AppRecurringIndexRoute: typeof AppRecurringIndexRoute
  AppDocumentsEditIdRoute: typeof AppDocumentsEditIdRoute
  AppProjectsWorkersIdRoute: typeof AppProjectsWorkersIdRoute
  AppProjectsWorkersIndexRoute: typeof AppProjectsWorkersIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppAdminRoute: AppAdminRoute,
  AppApiActivityRoute: AppApiActivityRoute,
  AppCustomersRoute: AppCustomersRoute,
  AppExpensesRoute: AppExpensesRoute,
  AppIntegrationRoute: AppIntegrationRoute,
  AppInvoicesRoute: AppInvoicesRoute,
  AppNotesRoute: AppNotesRoute,
  AppPaymentsRoute: AppPaymentsRoute,
  AppProductsRoute: AppProductsRoute,
  AppPurchasesRoute: AppPurchasesRoute,
  AppReceptionsRoute: AppReceptionsRoute,
  AppReportsRoute: AppReportsRoute,
  AppTicketsRoute: AppTicketsRoute,
  AppIndexRoute: AppIndexRoute,
  AppCustomersIdRoute: AppCustomersIdRoute,
  AppDocumentsIdRoute: AppDocumentsIdRoute,
  AppDocumentsNewRoute: AppDocumentsNewRoute,
  AppProjectsIdRoute: AppProjectsIdRoute,
  AppProjectsComplianceRoute: AppProjectsComplianceRoute,
  AppProjectsPositionsRoute: AppProjectsPositionsRoute,
  AppProjectsSettlementsRoute: AppProjectsSettlementsRoute,
  AppProjectsUnassignedRoute: AppProjectsUnassignedRoute,
  AppQuotesIdRoute: AppQuotesIdRoute,
  AppQuotesNewRoute: AppQuotesNewRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppQuotesIndexRoute: AppQuotesIndexRoute,
  AppRecurringIndexRoute: AppRecurringIndexRoute,
  AppDocumentsEditIdRoute: AppDocumentsEditIdRoute,
  AppProjectsWorkersIdRoute: AppProjectsWorkersIdRoute,
  AppProjectsWorkersIndexRoute: AppProjectsWorkersIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PTokenRoute: PTokenRoute,
  ResetPasswordTokenRoute: ResetPasswordTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
